module.exports = __webpack_public_path__ + "img/Una-Chaudhuri-Profile-Pic.06db466c.png";